<template>
  <div style="width: 100%; height: 100%;">
    <keep-alive>
      <second-nav-bar></second-nav-bar>
    </keep-alive>
    <div style="float: right; height: 100%; width: calc(100% - 200px);">基础配置</div>
  </div>
</template>

<script>
import SecondNavBar from '@/components/common/SecondNavBar'
export default {
  props: [],

  components: {
    'second-nav-bar': SecondNavBar
  },

  data () {
    return {

    }
  },

  watch: {

  },

  computed: {
  },

  mounted () {

  },

  methods: {
  }
}
</script>

<style lang="scss" scoped>
.header {
  float: right;
  display: flex;
  align-items: center;
  height: 60px;
  width: calc(100% - 60px);
  background: #ffffff;
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.12);
}
.header-title {
  height: 28px;
  margin-left: 25px;
  font-size: 20px;
  font-weight: 600;
  color: #444444;
  line-height: 28px;
}
.header-user {
  position: absolute;
  right: 20px;
}
/deep/ .el-dropdown {
  cursor: pointer;
}
.main-content {
  float: right;
  width: calc(100% - 60px);
  height: calc(100% - 60px);
}
</style>



// WEBPACK FOOTER //
// src/components/admin/ConfigManage.vue